import React from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function InfoContentBlockComponent({
  desktopImage,
  mobileImage,
  primaryText,
  readMoreUrl,
  readMore,
  label,
  imagePlacement,
  bottomPadding,
  topPadding,
  target,
}) {
  const imageAlignment = SelectionFactoryHelper.getFromSelectionFactory(imagePlacement)
  const mobileImageExists = mobileImage !== undefined ? true : false
  const windowWidth = useWindowWidth()
  const imageSrc = windowWidth < 768 && mobileImageExists ? mobileImage : desktopImage
  const tp = SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const bp = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)

  return (
    <div className={`info-content-block-container ${imageAlignment === "right" ? "img-right" : ""} ${tp ? tp : ""} ${bp ? bp : ""}`}>
      <div className="w--normal">
        {windowWidth >= 768 ? (
          <div className="inner-wrapper">
            <div className="row">
              <div className="half empty-space"></div>
              <div className="half infohead">{label}</div>
            </div>
            <div className="row img-row">
              <div className="half">
                <img className="background-pic" src={imageSrc} />
              </div>
              <div className="half">
                <div data-epi-property="Title" className="rich-text">
                  {ReactHtmlParser(primaryText)}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="half empty-space"></div>
              <a target={target[0]?.value || "_blank"} className="half button" href={readMoreUrl}>
                {readMore}
              </a>
            </div>
          </div>
        ) : (
          <>
            <img className="background-pic" src={imageSrc} />
            <div className="textside">
              <div className="infohead">{label}</div>
              <div>
                <div data-epi-property="Title" className="rich-text">
                  {ReactHtmlParser(primaryText)}
                </div>
              </div>
              <a target={target[0]?.value || "_blank"} className="button" href={readMoreUrl}>
                {readMore}
              </a>
              <div className="clear"></div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
